import queryString from "query-string";
import { CompanyAccountTab } from "./pages/company-account/CompanyAccountPage";

export type AppLinks = ReturnType<typeof getAppLinks>;

export const getAppLinks = () => {
  return {
    home: () => "/",
    login: () => "/login",
    companySignUp: () => "/company-sign-up",
    companyAccount: (tab?: CompanyAccountTab) => {
      const params = tab ? `?tab=${tab}` : "";
      return `/company-account${params}`;
    },
    chatbot: (conversationId?: string, messageId?: string) => {
      const stringified = `?${queryString.stringify({ conversationId, messageId })}`;

      return `/chatbot${stringified}`;
    },
    pdf: (
      chainlitKey: string = ":chainlitKey",
      name?: string,
      sessionId?: string,
      page?: number,
    ) => {
      const hash = page ? `#page=${page}` : "";
      const stringified = `?${queryString.stringify({ sessionId, name })}`;

      return `/pdf/${chainlitKey}${stringified}${hash}`;
    },
    prePdf: (
      conversationId: string = ":conversationId",
      messageId?: string,
      sourceId?: string,
    ) => {
      const stringified = `?${queryString.stringify({ messageId, sourceId })}`;

      return `/prepdf/${conversationId}${stringified}`;
    },
    paymentSuccess: () => "/payment-success",
    paymentFailure: () => "/payment-failure",
    termsAndConditions: () => "/terms-and-conditions",
    authProcess: () => "/auth-process",
    registrationSuccess: () => "/registration-success",
    passwordResetSuccess: () => "/password-reset-success",
    feedback: () => "/feedback",

    enterprisePlanBooking: () => "/enterprise-plan-booking",
    aboutScait: () => "/about-scait",
    contactSupport: () => "/contact-support",

    //SUPER ADMIN
    superAdmin: () => "/super-admin",
    superAdminCompanyDetail: (companyId?: string) =>
      `/super-admin/company/${companyId}`,
    superAdminEval: () => "/super-admin/eval",
    superAdminEvalDetail: (jobId?: number | string) =>
      `/super-admin/eval/${jobId}`,
  };
};
